import { PlanPurchaseExperienceSummaryLineProps } from './PlanPurchaseExperienceSummaryLine'
import { ReactNode } from 'react'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import { TextProps } from '@dtx-company/shared-components/src'
import theme from '../../../../theme'

interface Config {
  color: string
  variant: TextProps['variant']
}

function getConfig(appearance: PlanPurchaseExperienceSummaryLineProps['appearance']): Config {
  switch (appearance) {
    case 'primary':
      return {
        color: theme.colors.primary.black,
        variant: 'header/subheader'
      }
    case 'secondary':
      return {
        color: theme.colors.primary.grey,
        variant: 'body/medium'
      }
  }
  throw new Error(`Unexpected appearance: ${appearance}`)
}

interface PlanPurchaseExperienceSummaryLineValueProps {
  appearance: PlanPurchaseExperienceSummaryLineProps['appearance']
  children?: ReactNode
  color?: string
}

export function PlanPurchaseExperienceSummaryLineValue(
  props: PlanPurchaseExperienceSummaryLineValueProps
): JSX.Element {
  const config = getConfig(props.appearance)
  return (
    <>
      <Text component="span" variant={config.variant} color={props.color || config.color}>
        {props.children}
      </Text>
    </>
  )
}
